module.exports = __webpack_public_path__ + "static/media/learing-bulb-icon.aad4de7c.svg";